import React from 'react';
import { useStore } from 'routes/inventorize_meter/useStore';
import { FormattedMessage } from 'react-intl';
import { useInventorizeStepsStore } from '../../components/store';
import { Button } from '../../../../components/Button/Button';
import { FloorplanStepFooter as messages } from './messages';

export const FloorplanStepFooter: React.VFC = () => {
  const { commodity, newMeter } = useStore();
  const { setNextStep, setPreviousStep } = useInventorizeStepsStore();

  return (
    <>
      <Button block style={{ marginRight: 15 }} type="default" onClick={() => setPreviousStep({ commodity, newMeter })}>
        <FormattedMessage {...messages.back} />
      </Button>
      <Button
        key="submit"
        block
        form="floorplanStepForm"
        htmlType="submit"
        type="primary"
        onClick={() => setNextStep({ commodity, newMeter })}
      >
        <FormattedMessage {...messages.confirmFloorplan} />
      </Button>
    </>
  );
};
